// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationResetPasswordDefaultResponse {
    static getAttributeTypeMap() {
        return AuthenticationResetPasswordDefaultResponse.attributeTypeMap;
    }
}
AuthenticationResetPasswordDefaultResponse.discriminator = undefined;
AuthenticationResetPasswordDefaultResponse.additionalProperties = false;
AuthenticationResetPasswordDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Extauth2ProfileUpdateStatus"
    },
];
//# sourceMappingURL=authenticationResetPasswordDefaultResponse.js.map